import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SoundService } from '@org/shared-services';
import { Observable, Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { SoundPermissionModalComponent } from '../../../../shared-services/src/lib/notification/sound-permission-modal/sound-permission-modal.component';

@Component({
  selector: 'lib-audio-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './audio-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AudioIndicatorComponent implements OnInit, OnDestroy {
  soundEnabled$!: Observable<boolean | null>;
  soundEnabled: boolean | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private soundService: SoundService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.soundEnabled$ = this.soundService.permission$;
    this.soundEnabled$.subscribe(val => {
      this.soundEnabled = val;
      this.cdr.markForCheck();
    });
  }

  getSoundStateClass(soundEnabled: boolean | null): string {
    if (soundEnabled === true) return 'bg-green-100 ring-2 ring-green-400';
    if (soundEnabled === false) return 'bg-red-100 ring-2 ring-red-400';
    return 'bg-yellow-100 ring-2 ring-yellow-400';
  }

  getSoundIcon(soundEnabled: boolean | null): 'enabled' | 'disabled' | 'undecided' {
    if (soundEnabled === true) return 'enabled';
    if (soundEnabled === false) return 'disabled';
    return 'undecided';
  }

  requestPermission() {
    if (this.soundEnabled === null) {
      this.dialog.open(SoundPermissionModalComponent, {
        width: '400px',
        disableClose: true
      });
    } else if (this.soundEnabled === false) {
      this.soundService.setPermission(true);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
} 